var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sales-closures-table" },
    [
      _vm.isLoading
        ? _c("div", { staticClass: "flex justify-center items-center p-8" }, [
            _vm._m(0),
          ])
        : !_vm.closures || _vm.closures.length === 0
        ? _c(
            "div",
            { staticClass: "text-center p-8 text-gray-500" },
            [
              _c("p", [_vm._v("No hay cierres de ventas registrados")]),
              _c(
                "vs-button",
                {
                  staticClass: "mt-4",
                  attrs: { disabled: _vm.isOpeningForm },
                  on: { click: _vm.openCreateModal },
                },
                [
                  _vm.isOpeningForm
                    ? _c("i", {
                        staticClass: "spinner-border-button mr-2",
                        attrs: { role: "status", "aria-hidden": "true" },
                      })
                    : _c("i", { staticClass: "feather icon-plus" }),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.isOpeningForm
                          ? "Cargando..."
                          : "Crear primer cierre"
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "space-y-4" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "overflow-x-auto rounded-lg border border-gray-200",
                },
                [
                  _c("table", { staticClass: "w-full text-sm" }, [
                    _c("thead", { staticClass: "bg-grey-light" }, [
                      _c("tr", [
                        _c(
                          "th",
                          { staticClass: "px-4 py-3 text-left font-semibold" },
                          [_vm._v("#")]
                        ),
                        _c(
                          "th",
                          { staticClass: "px-4 py-3 text-left font-semibold" },
                          [_vm._v("Estado")]
                        ),
                        _c(
                          "th",
                          { staticClass: "px-4 py-3 text-left font-semibold" },
                          [_vm._v("Empresa")]
                        ),
                        _c(
                          "th",
                          { staticClass: "px-4 py-3 text-left font-semibold" },
                          [_vm._v("Modo Fact.")]
                        ),
                        _c(
                          "th",
                          { staticClass: "px-4 py-3 text-left font-semibold" },
                          [_vm._v("Fechas")]
                        ),
                        _c(
                          "th",
                          { staticClass: "px-4 py-3 text-right font-semibold" },
                          [_vm._v("Monto Original")]
                        ),
                        _vm.isMultiCurrency
                          ? _c(
                              "th",
                              {
                                staticClass:
                                  "px-4 py-3 text-right font-semibold",
                              },
                              [_vm._v("Monto USD")]
                            )
                          : _vm._e(),
                        _c(
                          "th",
                          { staticClass: "px-4 py-3 text-left font-semibold" },
                          [_vm._v("Autor")]
                        ),
                        _c(
                          "th",
                          {
                            staticClass: "px-4 py-3 text-center font-semibold",
                          },
                          [_vm._v("Acciones")]
                        ),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.closures, function (closure) {
                        return _c(
                          "tr",
                          {
                            key: closure.id,
                            class: _vm.getRowClasses(closure),
                          },
                          [
                            _c(
                              "td",
                              { staticClass: "px-4 py-3 font-semibold" },
                              [
                                _vm._v(
                                  _vm._s(_vm.getClosureDisplayNumber(closure))
                                ),
                              ]
                            ),
                            _c("td", { staticClass: "px-4 py-3" }, [
                              _c(
                                "div",
                                { staticClass: "flex items-center gap-1" },
                                [
                                  _c(
                                    "vs-chip",
                                    {
                                      staticClass: "text-white",
                                      attrs: {
                                        color:
                                          _vm.CLOSURE_STATUS_COLORS[
                                            closure.status
                                          ],
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          closure.status === "draft"
                                            ? {
                                                key: "icon",
                                                fn: function () {
                                                  return [
                                                    _c("i", {
                                                      staticClass:
                                                        "feather icon-alert-circle",
                                                    }),
                                                  ]
                                                },
                                                proxy: true,
                                              }
                                            : null,
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.CLOSURE_STATUS_LABELS[
                                              closure.status
                                            ]
                                          ) +
                                          "\n                  "
                                      ),
                                    ]
                                  ),
                                  closure.status === "canceled" &&
                                  closure.cancellation_comment
                                    ? _c("feather-icon", {
                                        attrs: {
                                          icon: "InfoIcon",
                                          svgClasses:
                                            "w-4 h-4 text-danger cursor-pointer flex-shrink-0",
                                          title: "Ver motivo de anulación",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.openReasonModal(
                                              closure.cancellation_comment
                                            )
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "px-4 py-3 text-sm font-medium text-gray-700",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.getClosureLegalName(closure)) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _c("td", { staticClass: "px-4 py-3 text-xs" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.BILLING_MODES_LABELS[
                                      closure.billing_mode
                                    ]
                                  ) +
                                  "\n            "
                              ),
                            ]),
                            _c(
                              "td",
                              { staticClass: "px-4 py-3 whitespace-nowrap" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.dateFormatter(closure.date_from)
                                    ) +
                                    " - " +
                                    _vm._s(_vm.dateFormatter(closure.date_to)) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _c(
                              "td",
                              {
                                staticClass:
                                  "px-4 py-3 text-right font-semibold text-latinad",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.stringCurrencyFormatter(
                                        closure.amount
                                      )
                                    ) +
                                    " " +
                                    _vm._s(closure.currency) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm.isMultiCurrency
                              ? _c(
                                  "td",
                                  {
                                    staticClass:
                                      "px-4 py-3 text-right font-semibold text-latinad",
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.stringCurrencyFormatter(
                                            closure.amount_usd || closure.amount
                                          )
                                        ) +
                                        " USD\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c("td", { staticClass: "px-4 py-3 text-sm" }, [
                              closure.author
                                ? _c("span", { staticClass: "text-gray-700" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(closure.author.first_name) +
                                        " " +
                                        _vm._s(closure.author.last_name) +
                                        "\n                "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "text-gray-500 text-xs" },
                                      [
                                        _vm._v(
                                          "(" +
                                            _vm._s(closure.author.email) +
                                            ")"
                                        ),
                                      ]
                                    ),
                                  ])
                                : _c(
                                    "span",
                                    { staticClass: "text-gray-400 italic" },
                                    [_vm._v("Sin información")]
                                  ),
                            ]),
                            _c("td", { staticClass: "px-4 py-3" }, [
                              _c(
                                "div",
                                { staticClass: "flex justify-center gap-2" },
                                [
                                  closure.status === "canceled"
                                    ? _c(
                                        "vs-button",
                                        {
                                          staticClass:
                                            "bg-info text-white hover:bg-information",
                                          attrs: {
                                            icon: "",
                                            size: "small",
                                            title: `Ver detalles del cierre ${_vm.getClosureDisplayNumber(
                                              closure
                                            )}`,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.viewClosure(closure)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "feather icon-eye",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  closure.status !== "canceled"
                                    ? _c(
                                        "vs-button",
                                        {
                                          staticClass:
                                            "bg-warning text-white hover:bg-yellow-600",
                                          attrs: {
                                            icon: "",
                                            size: "small",
                                            title: `Editar cierre ${_vm.getClosureDisplayNumber(
                                              closure
                                            )}`,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.editClosure(closure)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "feather icon-edit",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                  closure.status !== "canceled"
                                    ? _c(
                                        "vs-button",
                                        {
                                          staticClass:
                                            "bg-danger text-white hover:bg-red-600",
                                          attrs: {
                                            icon: "",
                                            size: "small",
                                            disabled:
                                              _vm.hasBillingActive(closure),
                                            title: _vm.hasBillingActive(closure)
                                              ? "No se puede anular: tiene una facturación activa."
                                              : `Anular cierre ${_vm.getClosureDisplayNumber(
                                                  closure
                                                )}`,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.cancelClosure(closure)
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "feather icon-trash-2",
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "p-3 px-4 flex justify-between items-center bg-grey-light rounded-lg mt-4",
                },
                [
                  _c("span", { staticClass: "text-sm font-semibold" }, [
                    _vm._v("\n        Total USD:\n      "),
                  ]),
                  _c("span", { staticClass: "font-bold text-latinad" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.stringCurrencyFormatter(
                            _vm.currencyTotals.byCurrency["USD"]
                          )
                        ) +
                        " USD\n      "
                    ),
                  ]),
                ]
              ),
              _c(
                "vs-button",
                {
                  staticClass:
                    "mt-6 w-full bg-latinad text-white hover:bg-latinad-light",
                  attrs: { disabled: _vm.isOpeningForm },
                  on: { click: _vm.openCreateModal },
                },
                [
                  _vm.isOpeningForm
                    ? _c("i", {
                        staticClass: "spinner-border-button mr-2",
                        attrs: { role: "status", "aria-hidden": "true" },
                      })
                    : _c("i", { staticClass: "feather icon-plus-circle mr-2" }),
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.isOpeningForm ? "Cargando..." : "Crear nuevo cierre"
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          ),
      _vm.selectedClosure
        ? _c("sales-closures-details", {
            attrs: {
              active: _vm.isDetailModalOpen,
              closure: _vm.selectedClosure,
            },
            on: {
              "update:active": function ($event) {
                _vm.isDetailModalOpen = $event
              },
              close: _vm.handleDetailClose,
            },
          })
        : _vm._e(),
      _c("sales-closures-form", {
        attrs: {
          active: _vm.isFormModalOpen,
          "campaign-id": _vm.campaignId,
          closure: _vm.editingClosure,
          "existing-closures": _vm.closures,
        },
        on: {
          "update:active": function ($event) {
            _vm.isFormModalOpen = $event
          },
          "loading-change": _vm.handleFormLoadingChange,
          save: _vm.handleSave,
          cancel: _vm.handleFormCancel,
        },
      }),
      _c(
        "vs-popup",
        {
          staticClass: "cancel-closure-modal",
          attrs: { title: "", active: _vm.cancelModalActive },
          on: {
            "update:active": function ($event) {
              _vm.cancelModalActive = $event
            },
            close: _vm.closeCancelModal,
          },
        },
        [
          _c("div", { staticClass: "cancel-closure-body" }, [
            _c(
              "button",
              {
                staticClass: "popup-close",
                on: { click: _vm.closeCancelModal },
              },
              [_vm._v("✕")]
            ),
            _c(
              "div",
              { staticClass: "cancel-closure-icon" },
              [
                _c("feather-icon", {
                  attrs: { icon: "AlertTriangleIcon", svgClasses: "w-8 h-8" },
                }),
              ],
              1
            ),
            _c("h3", { staticClass: "cancel-closure-title" }, [
              _vm._v("Anular cierre"),
            ]),
            _c("p", { staticClass: "cancel-closure-message" }, [
              _vm._v(
                "\n        ¿Está seguro de que desea anular el cierre #" +
                  _vm._s(
                    _vm.closureToCancel
                      ? _vm.getClosureDisplayNumber(_vm.closureToCancel)
                      : ""
                  ) +
                  "?"
              ),
              _c("br"),
              _vm._v("\n        Esta acción no se puede deshacer.\n      "),
            ]),
            _c(
              "div",
              { staticClass: "cancel-closure-field" },
              [
                _c("label", { staticClass: "cancel-closure-label" }, [
                  _vm._v("Comentario"),
                ]),
                _c("vs-textarea", {
                  attrs: {
                    rows: 3,
                    maxlength: "1000",
                    placeholder:
                      "Indique el motivo de anulación, campo obligatorio",
                  },
                  model: {
                    value: _vm.cancelComment,
                    callback: function ($$v) {
                      _vm.cancelComment = $$v
                    },
                    expression: "cancelComment",
                  },
                }),
                _vm.cancelComment.trim().length > 0 &&
                _vm.cancelComment.trim().length < 10
                  ? _c("p", { staticClass: "cancel-closure-hint" }, [
                      _vm._v("\n          Mínimo 10 caracteres.\n        "),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "cancel-closure-actions" },
              [
                _c(
                  "vs-button",
                  {
                    attrs: { type: "border", color: "dark" },
                    on: { click: _vm.closeCancelModal },
                  },
                  [_vm._v("Cancelar")]
                ),
                _c(
                  "vs-button",
                  {
                    attrs: {
                      color: "danger",
                      disabled:
                        _vm.cancelComment.trim().length < 10 ||
                        _vm.isCancelingClosure,
                    },
                    on: { click: _vm.confirmCancelClosure },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.isCancelingClosure ? "Anulando..." : "Anular"
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c("comment-modal", {
        staticClass: "reason-modal-zfix",
        attrs: {
          modalActive: _vm.reasonModalActive,
          comment: _vm.reasonModalText,
          title: "Motivo de anulación",
        },
        on: {
          "update:modalActive": function ($event) {
            _vm.reasonModalActive = $event
          },
          "update:modal-active": function ($event) {
            _vm.reasonModalActive = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c("div", { staticClass: "spinner mb-2" }, [
        _c(
          "div",
          { staticClass: "spinner-border", attrs: { role: "status" } },
          [_c("span", { staticClass: "sr-only" }, [_vm._v("Cargando...")])]
        ),
      ]),
      _c("p", { staticClass: "text-sm text-gray-500" }, [
        _vm._v("Cargando cierres de ventas..."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }